import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import { PercentFigure } from '../../Figure/index.jsx';

import Column from './base.jsx';

import ColumnLabels from '@data/nft-collections/columns.json';


var columnOptions = {
  id: 'k',
  title: 'Secondary Sales Royalty'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get overlayText() {
    return ColumnLabels.royalty.description;
  }

  get rightAlign() {
    return true;
  }
}


var DetailColumn = function(props) {
  return (
    <td className="text-right">
      <PercentFigure
        amount={props.row.secondarySalesRoyalty * 100}
        formatter="medium"
        displaySign={false}
        highlightPositive={false}
      />
    </td>
  );
}


class SecondarySalesRoyalty extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.secondarySalesRoyalty < b.secondarySalesRoyalty) {
      return -1;
    }
    if (a.secondarySalesRoyalty > b.secondarySalesRoyalty) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.secondarySalesRoyalty < b.secondarySalesRoyalty) {
      return 1;
    }
    if (a.secondarySalesRoyalty > b.secondarySalesRoyalty) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default SecondarySalesRoyalty;

